import axios from 'axios';

const BASE_URL = 'https://webback.opencurtainscasting.com/';
// const BASE_URL = "http://localhost:5000/"

export const getContent = async () => {
  try {
    const res = await axios.get(`${BASE_URL}content/get`);
    return res;
  } catch (error) {
    console.error(
      'Error fetching content',
      error.response?.data || error.message
    );
    throw error;
  }
};
